/* eslint-disable react/prefer-stateless-function */
/* eslint-disable max-classes-per-file */
import React, { Component } from 'react';
import EvaluationComponent from '../../components/BotComponents/EvaluationComponent';
import ImproperliesComponent from '../../components/BotComponents/ImproperliesComponent';
import RepetitionComponent from '../../components/BotComponents/RepetitionComponent';
import RivescriptComponent from '../../components/BotComponents/RivescriptComponent';
import ComponentsType from '../../components/Component/ComponentType';
import ComponentConfigurationBreadCrumbs from './ComponentConfigurationsBreadCrumbs';
import ComponentConfigurationRemoveButton from './ComponentConfigurationsRemoveButton';
import ComponentConfigurationTitleInput from './ComponentConfigurationsTitleInput';
import ComponentConfigurationHelpButton from './ComponentConfigurationsHelpButton';
import LocalizationComponentAccordionItem from './LocalizationComponentAccordionItem';

import DialogNotification from '../../components/DialogNotification/DialogNotification';
import AutomaticReply from '../../components/BotComponents/AutomaticReplyComponent';

import style from './ComponentConfigurations.module.css';
import FAQComponent from '../../components/BotComponents/FAQComponent/FAQComponent';
import { GPTComponent } from '../../components/BotComponents/GPTComponent/GPTComponent';
import HierarchicalComponent from '../../components/BotComponents/HierarchicalComponent/HierarchicalComponent';

/**
 *  Componente de edição das configurações do componentes do fluxo
 *  Precisa ser empacotado dentro de um ConfigurationsBox
 */
class ComponentConfigurations extends Component {
  constructor() {
    super();
    this.state = {
      component: null,
      boxConfigurationOpened: false,
      componentIsValid: true,
      titleIsValid: true,
      removeComponent: false,
      showHelperDialog: false,
      helperContent: '',
    };

    this.setState = this.setState.bind(this);
  }

  componentDidMount() {
    this.props.setWidth('m5');
    if (this.props.contextFlow) {
      this.initComponentConfigurations();
    }
  }

  componentDidUpdate(_prevProps, prevState) {
    this.props.setScroll(true);
    const { componentSelected } = this.props;
    if (componentSelected) {
      const componenteSelectedHasChanged = componentSelected.id !== this.state.component.id;
      const confKeepClose = !prevState.boxConfigurationOpened && !this.state.boxConfigurationOpened;
      /** Inicializa componente novamente, se existir mudança de componente selecionado,
       *  ou se não existir mas a configuração estiver fechada.
       *  Isso significa que a configuração do componente foi fechada e agora está sendo reaberta */
      if (componenteSelectedHasChanged
        || (!componenteSelectedHasChanged && confKeepClose)) {
        this.initComponentConfigurations();
      }

      this.openOrCloseConfigurationBox(prevState);
      this.removeComponent();
    }
  }

  componentWillUnmount() {
    /** Limpa o estado para permitir a desmontagem do componente,
    quando o box de configuração for fechado */
    this.setState = () => { };
  }

  /** Se o estado removeComponent for true, então procede a remoção do componente */
  removeComponent = () => {
    if (this.state.removeComponent && !this.state.boxConfigurationOpened) {
      this.setState({ removeComponent: false });
      this.props.removeElementFlow(this.state.component);
    }
  }

  /** Abri a caixa de configuração se o estado
  *  boxConfigurationOpened for alterado de false para true.
  *  Fecha a caixa de configuração se o estado
  *  boxConfigurationOpened for alterado de true para false */
  openOrCloseConfigurationBox = (prevState) => {
    const confClosedBeforeOpenNow = !prevState.boxConfigurationOpened
      && this.state.boxConfigurationOpened;
    const confOpenBeforeCloseNow = prevState.boxConfigurationOpened
      && !this.state.boxConfigurationOpened;
    if (confClosedBeforeOpenNow) {
      this.props.setBoxOpened(true);
    } else if (confOpenBeforeCloseNow) {
      this.props.setBoxOpened(false);
    }
  }

  /** Inicializa o componente,
   *
   * Habilita a ação de "click fora da caixa de configuração".
   * Altera o estado com valores iniciais adequados para o funcionamento  */
  initComponentConfigurations = () => {
    this.enableClickOut();

    const { componentSelected } = this.props;
    const environmentConfigurations = this.props.contextFlow.environment;

    /** Recupera description, engineRelease e parameters da
     * versão do componente selecionado carregado no contexto */
    let description = '';
    let engineRelease = '';
    let parameters = [];
    let knowledgeBases = [];

    const flowBot = this.props.contextFlow.bots.find((b) => b.id === componentSelected.id);

    if (flowBot) {
      knowledgeBases = flowBot.knowledgeBases;
    }
  
    for (const el of this.props.contextFlow.stack.supportedEngineReleases) {
      if (componentSelected.typeElement.title === el.engine.name) {
        description = el.engine.description;
        engineRelease = el.id;
        parameters = componentSelected.parameters
          ? componentSelected.parameters
          : el.parameters.map((p) => ({ parameter: p, value: p.defaultValue }));
        break;
      }
    }

    this.setState(
      {
        component: {
          ...componentSelected,
          description,
          engineRelease,
          environmentConfigurations,
          knowledgeBases,
          parameters,
        },
        boxConfigurationOpened: true,
      },
    );
  }

  /** Atualiza um parametro do componente */
  updateParameter = (parameterUpdated) => {
    const { parameters } = this.state.component;
    const parameterType = parameterUpdated.parameter.id;
    const parameterHaveToChangeId = parameters.findIndex((p) => p.parameter.id === parameterType);
    parameters[parameterHaveToChangeId] = parameterUpdated;

    this.setState((prev) => ({
      component: {
        ...prev.component,
        parameters,
      },
    }));
  }

  /** Manipula o evento de click fora da caixa de configuração do componente
   *
   *  Define se o componente é valido através do atributo isValid.
   *  Esse atributo é usado no conversartionFlow para controlar a atualização do fluxo no servidor
   *  e apresentar notificações para usuário
   *
   *  Chama o metodo updateNode que tenta atualiza o no que representa o componente no fluxo
   *  e o componente no contexto
   */
  clickOutHandle = (e) => {
    if (this.props.boxRef.current.contains(e.target)) return;

    const { component } = this.state;
    component.isValid = (this.state.componentIsValid && this.state.titleIsValid);

    this.props.updateNode(component.id, component);
    this.setState({ boxConfigurationOpened: false });

    document
      .querySelector('.backdrop')
      .removeEventListener('mousedown', this.clickOutHandle);
  };

  /** Habilita a ação de "click fora da caixa de configuração" */
  enableClickOut = () => {
    document
      .querySelector('.backdrop')
      .addEventListener('mousedown', this.clickOutHandle);
  };

  /** Compõe painel para edição dos componentes, adicionando propriedades comuns no componente base
   * @param {*} componentBase Componente base do painel  */
  composeComponentEditorPanel = (componentBase) => React.cloneElement(componentBase, {
    component: this.state.component,
    localizationAccordionItem: <LocalizationComponentAccordionItem parent={this} />,
    updateParameter: this.updateParameter,
    componentIsValid: (e) => this.setState({ componentIsValid: e }),
    setHelperContent: (e) => this.setState({ helperContent: e }),
  });

  /** Mostra o para edição do componente selecionado de acordo com o estado component.typeElement
   * @returns painel para edição dos componentes */
  showComponentEditorPanel = () => {
    switch (this.state.component.typeElement.id) {
      case ComponentsType.RIVESCRIPT.id: {
        return this.composeComponentEditorPanel(<RivescriptComponent />);
      }
      case ComponentsType.REPETICAO.id: {
        return this.composeComponentEditorPanel(<RepetitionComponent />);
      }
      case ComponentsType.IMPROPRIEDADES.id: {
        return this.composeComponentEditorPanel(<ImproperliesComponent />);
      }
      case ComponentsType.AVALIACAO.id: {
        return this.composeComponentEditorPanel(<EvaluationComponent />);
      }
      case ComponentsType.RESPOSTA_AUTOMATICA.id: {
        return this.composeComponentEditorPanel(<AutomaticReply />);
      }
      case ComponentsType.PERGUNTAS_E_RESPOSTAS.id: {
        return this.composeComponentEditorPanel(<FAQComponent />);
      }
      case ComponentsType.ASSUNTO_DESCONHECIDO.id: {
        return this.composeComponentEditorPanel(<AutomaticReply />);
      }
      case ComponentsType.MS_GPT.id: {
        return this.composeComponentEditorPanel(<GPTComponent />);
      }
      case ComponentsType.HIERARCHICAL.id: {
        return this.composeComponentEditorPanel(<HierarchicalComponent />);
      }
      default: return <></>;
    }
  }

  /** Mostra uma caixa de dialogo que explica como funciona o componente */
  showHelperDialogComponent = () => {
    if (this.state.showHelperDialog) {
      return (
        <DialogNotification
          color="info"
          title={<p>Como funciona esse componente?</p>}
          content={<div className={style.Helper}>{this.state.helperContent}</div>}
          okAction={() => this.setState({ showHelperDialog: false })}
        />
      );
    }
  }

  render() {
    if (this.state.component) {
      return (
        <>
          {this.showHelperDialogComponent()}
          <div className={style.Header}>
            <ComponentConfigurationBreadCrumbs
              title={this.props.componentSelected.typeElement.title}
              label={this.props.componentSelected.label}
            />
            <ComponentConfigurationTitleInput
              label={this.state.component.label}
              titleIsValid={this.state.titleIsValid}
              setState={this.setState}
              component={this.state.component}
              componentsListNames={this.props.componentsListNames}
            />
            <ComponentConfigurationHelpButton
              setState={this.setState}
            />
            <ComponentConfigurationRemoveButton
              component={this.state.component}
              setState={this.setState}
            />
            <div className="clearfix" />
          </div>
          {this.showComponentEditorPanel()}
        </>
      );
    }
    return null;
  }
}

export default ComponentConfigurations;
